import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/browser';
import axios from 'axios';

import 'antd/dist/antd.css';
import './index.less';
import Maintenance from 'containers/Maintenance/Maintenance.container';
import App from './containers';
import * as serviceWorker from './serviceWorker';

import Auth0Service from './shared/services/Auth0Service';

if (!window.location.hostname.includes('localhost')) {
  Sentry.init({
    environment: process.env.SENTRY_ENV,
    dsn: process.env.SENTRY_URL,
  });
}

class Init extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      maintenance: true,
      loading: true,
    };
  }

  _onGetConfigSuccess = res => {
    const isMaintenance = res.data.payload.configs.maintenance_mode;
    this.setState({ maintenance: isMaintenance }, () => {
      if (!isMaintenance) {
        Auth0Service.getInstance()
          .init()
          .then(() =>
            this.setState({
              loading: false,
            }),
          );
      } else {
        this.setState({
          loading: false,
        });
      }
    });
  };

  _onGetConfigError = () => {
    // Should set maintenance mode in production if get config error
    this.setState({
      loading: false,
    });

    // NOTE: uncomment for development (bypass server config)
    // this.setState({ maintenance: false }, () => {
    //   Auth0Service.getInstance()
    //     .init()
    //     .then(() =>
    //       this.setState({
    //         loading: false,
    //       }),
    //     );
    // });
  };

  componentDidMount() {
    axios
      .get(process.env.CONFIG_URL)
      .then(this._onGetConfigSuccess)
      .catch(this._onGetConfigError);
  }

  render() {
    if (!this.state.maintenance) {
      return <App />;
    }
    if (this.state.loading) {
      return null;
    }
    return <Maintenance />;
  }
}

ReactDOM.render(<Init />, document.getElementById('root'));

serviceWorker.register();
